module.exports = __webpack_public_path__ + "img/skyline-bottom.1121bf17.svg";